import React, { useState, useEffect } from 'react';

import {
  Form,
  FormItem,
  SubmitButton,
  Input,
  Button,
  EditableInput,
} from '../../components';
import { DnDTip } from '../../components/TextSearchReplace/components';
import { validateNameLength } from '../../utilities';
import { validateIdentifier } from './validateIdentifier';
import type { SystemPrompt } from '../../api';

export type FormProps = {
  title: string;
  prompt: string;
  identifier: string;
};
type VectorizeFormProps = {
  saving: boolean;
  onCancel: () => void;
  onSave: (data: SystemPrompt) => void;
  initialValue?: SystemPrompt;
  buttonLabel?: string;
};

const PromptForm: React.FC<VectorizeFormProps> = ({
  onSave,
  onCancel,
  initialValue,
  buttonLabel = 'Add',
}) => {
  const getInitialValues = (val?: Partial<FormProps>): FormProps => ({
    title: val?.title ?? '',
    prompt: val?.prompt ?? '',
    identifier: val?.identifier ?? '',
  });

  const [values, setValues] = useState<FormProps>(
    getInitialValues(initialValue)
  );

  useEffect(() => {
    setValues(getInitialValues(initialValue));
  }, [initialValue]);

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={setValues} initialValue={values}>
        <div className="flex gap-x-2 col-2">
          <FormItem<FormProps>
            required
            name="title"
            label="Title"
            inline={false}
            validate={value => validateNameLength(value, { min: 2, max: 120 })}
          >
            <Input />
          </FormItem>
          <FormItem<FormProps>
            required
            name="identifier"
            label="Identifier"
            inline={false}
            validate={value => validateIdentifier(value, { min: 2, max: 120 })}
          >
            <Input readonly={!!initialValue?.identifier} />
          </FormItem>
        </div>
        <div className="border p-4 border-border rounded-md bg-gray-50">
          <FormItem<FormProps>
            required
            name="prompt"
            label="Prompt"
            inline={false}
            renderError={() => null}
          >
            <EditableInput multiline disabled={false} />
          </FormItem>
        </div>

        <div className="flex items-center w-full justify-between gap-x-4">
          <DnDTip />
          <div className="flex gap-x-4">
            <Button
              size="medium"
              type="contrast"
              label="Cancel"
              className="text-main flex-1 min-w-0"
              onClick={onCancel}
            />
            <SubmitButton
              size="medium"
              disabled={false}
              label={buttonLabel}
              className="flex-1 min-w-0"
              onClick={() =>
                onSave({
                  title: values?.title ?? '',
                  prompt: values?.prompt ?? '',
                  identifier: values?.identifier ?? '',
                })
              }
            />
          </div>
        </div>
      </Form>
    </div>
  );
};

export default PromptForm;
